import React from "react"
class Dropdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dropdown: false,
    }
    this.dropdownRef = React.createRef();
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.toggle = this.toggle.bind(this);
    this.handleBoxClick = this.handleBoxClick.bind(this);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.state.dropdown) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    this.setState({ dropdown: true }, () => {
      document.addEventListener("click", this.handleBoxClick)
    })
  }

  hide() {
    this.setState({ dropdown: false }, () => {
      document.removeEventListener("click", this.handleBoxClick)
    })
  }

  handleBoxClick(event) {
    if (this.props.keepOpenOnSelect && this.dropdownRef.current) {
      if (this.dropdownRef.current.contains(event.target))
        return;
    }
    this.hide();
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleBoxClick);
  }

  render() {
    return (
      <div
        ref={this.dropdownRef}
        className={this.props.className ? this.props.className : "dropdown"}
        disabled={this.props.disabled}
      >
        {this.props.componentTriggeringDropdown(this.toggle)}
        {this.state.dropdown ? (
          <div className="mt-2 2xl:mt-2 rounded-md bg-white shadow-lg z-10" style={{ minWidth: "250px" }}>
            {this.props.children}
          </div>
        ) : null}
      </div>
    )
  }
}

export default Dropdown
